import { useState } from 'react';

interface SlimHeaderProps {
  logoUrl: string | null | undefined;
  orgName: string;
  title: string;
  /** 0–1. When given, the header's brand rule becomes a progress ribbon filled to this fraction. */
  progress?: number;
}

/**
 * The hosted pages' header: org logo left, page title right, a brand rule underneath
 * (styles in styles/pages.scss, `.slim-header`). Both sit inside the one h1, so wherever a host
 * page styles headings (its display face, say) the org's name takes that face too when it has
 * no logo, or a broken one, and shows as text. With `progress`, the rule turns into a track and
 * a brand-coloured fill grows along it.
 */
function SlimHeader({ logoUrl, orgName, title, progress }: SlimHeaderProps) {
  const [logoBroken, setLogoBroken] = useState(false);
  const hasProgress = typeof progress === 'number';
  return (
    <header className={`slim-header${hasProgress ? ' slim-header--progress' : ''}`}>
      <h1 className="slim-header-heading">
        {logoUrl && !logoBroken ? (
          <img className="slim-header-logo" src={logoUrl} alt={orgName} onError={() => setLogoBroken(true)} />
        ) : (
          <span className="slim-header-org">{orgName}</span>
        )}
        <span className="slim-header-title">{title}</span>
      </h1>
      {hasProgress && (
        <span
          className="slim-header-progress"
          style={{ width: `${Math.round(Math.min(1, Math.max(0, progress)) * 100)}%` }}
          aria-hidden="true"
        />
      )}
    </header>
  );
}

export default SlimHeader;
